var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.975 40.536 1.968 20.932a6 6 0 0 1 9.064-7.864l15.821 18.236L52.934.74a2.06 2.06 0 0 1 2.48-.533 2.03 2.03 0 0 1 1.115 2.294l-9.176 41.021 20.3 7.576c.62.245 1.114.739 1.284 1.391.165.658 0 1.31-.412 1.843L57.772 66.944l18.76 21.624a6 6 0 0 1-9.064 7.864l-17.57-20.253-24.832 29.125a2.14 2.14 0 0 1-1.57.696c-.33 0-.62-.082-.91-.206a2.03 2.03 0 0 1-1.115-2.294l9.176-41.02-20.3-7.577c-.62-.244-1.114-.739-1.284-1.391-.165-.657 0-1.31.412-1.842z"
  })));
};

export default SvgNo;